// AUTO-GENERATED by isa/codegen.py — do not edit directly.
// Source of truth: spec/isa.json  (field: handler)

import { Op } from "./_isa_tables.js";

export const DISPATCH_CONFIG = [
    [Op.MOV_REG_REG, "direct", "_hMovRegReg"],
    [Op.MOV_REG_ADDR, "direct", "_hMovRegAddr"],
    [Op.MOV_REG_REGADDR, "direct", "_hMovRegRegaddr"],
    [Op.MOV_ADDR_REG, "direct", "_hMovAddrReg"],
    [Op.MOV_REGADDR_REG, "direct", "_hMovRegaddrReg"],
    [Op.MOV_REG_CONST, "direct", "_hMovRegConst"],
    [Op.MOV_ADDR_CONST, "direct", "_hMovAddrConst"],
    [Op.MOV_REGADDR_CONST, "direct", "_hMovRegaddrConst"],
    [Op.ADD_REG_REG, "alu_2op", "add", "stkReg"],
    [Op.ADD_REG_REGADDR, "alu_2op", "add", "regaddr"],
    [Op.ADD_REG_ADDR, "alu_2op", "add", "addr"],
    [Op.ADD_REG_CONST, "alu_2op", "add", "const"],
    [Op.SUB_REG_REG, "alu_2op", "sub", "stkReg"],
    [Op.SUB_REG_REGADDR, "alu_2op", "sub", "regaddr"],
    [Op.SUB_REG_ADDR, "alu_2op", "sub", "addr"],
    [Op.SUB_REG_CONST, "alu_2op", "sub", "const"],
    [Op.INC_REG, "direct", "_hInc"],
    [Op.DEC_REG, "direct", "_hDec"],
    [Op.CMP_REG_REG, "alu_2op_no_wb", "sub", "stkReg"],
    [Op.CMP_REG_REGADDR, "alu_2op_no_wb", "sub", "regaddr"],
    [Op.CMP_REG_ADDR, "alu_2op_no_wb", "sub", "addr"],
    [Op.CMP_REG_CONST, "alu_2op_no_wb", "sub", "const"],
    [Op.JMP_REG, "direct", "_hJmpReg"],
    [Op.JMP_ADDR, "direct", "_hJmpAddr"],
    [Op.JC_REG, "jcc", "c", "reg"],
    [Op.JC_ADDR, "jcc", "c", "addr"],
    [Op.JNC_REG, "jcc", "nc", "reg"],
    [Op.JNC_ADDR, "jcc", "nc", "addr"],
    [Op.JZ_REG, "jcc", "z", "reg"],
    [Op.JZ_ADDR, "jcc", "z", "addr"],
    [Op.JNZ_REG, "jcc", "nz", "reg"],
    [Op.JNZ_ADDR, "jcc", "nz", "addr"],
    [Op.JA_REG, "jcc", "a", "reg"],
    [Op.JA_ADDR, "jcc", "a", "addr"],
    [Op.JNA_REG, "jcc", "na", "reg"],
    [Op.JNA_ADDR, "jcc", "na", "addr"],
    [Op.PUSH_REG, "direct", "_hPushReg"],
    [Op.PUSH_REGADDR, "direct", "_hPushRegaddr"],
    [Op.PUSH_ADDR, "direct", "_hPushAddr"],
    [Op.PUSH_CONST, "direct", "_hPushConst"],
    [Op.POP_REG, "direct", "_hPopReg"],
    [Op.CALL_REG, "direct", "_hCallReg"],
    [Op.CALL_ADDR, "direct", "_hCallAddr"],
    [Op.RET, "direct", "_hRet"],
    [Op.MUL_REG, "muldiv", "mul", "muldivReg"],
    [Op.MUL_REGADDR, "muldiv", "mul", "muldivRegaddr"],
    [Op.MUL_ADDR, "muldiv", "mul", "muldivAddr"],
    [Op.MUL_CONST, "muldiv", "mul", "muldivConst"],
    [Op.DIV_REG, "div", "muldivReg"],
    [Op.DIV_REGADDR, "div", "muldivRegaddr"],
    [Op.DIV_ADDR, "div", "muldivAddr"],
    [Op.DIV_CONST, "div", "muldivConst"],
    [Op.AND_REG_REG, "bitwise", "and", "gprReg"],
    [Op.AND_REG_REGADDR, "bitwise", "and", "regaddr"],
    [Op.AND_REG_ADDR, "bitwise", "and", "addr"],
    [Op.AND_REG_CONST, "bitwise", "and", "const"],
    [Op.OR_REG_REG, "bitwise", "or", "gprReg"],
    [Op.OR_REG_REGADDR, "bitwise", "or", "regaddr"],
    [Op.OR_REG_ADDR, "bitwise", "or", "addr"],
    [Op.OR_REG_CONST, "bitwise", "or", "const"],
    [Op.XOR_REG_REG, "bitwise", "xor", "gprReg"],
    [Op.XOR_REG_REGADDR, "bitwise", "xor", "regaddr"],
    [Op.XOR_REG_ADDR, "bitwise", "xor", "addr"],
    [Op.XOR_REG_CONST, "bitwise", "xor", "const"],
    [Op.NOT_REG, "direct", "_hNot"],
    [Op.SHL_REG_REG, "shift", "shl", "gprReg"],
    [Op.SHL_REG_REGADDR, "shift", "shl", "regaddr"],
    [Op.SHL_REG_ADDR, "shift", "shl", "addr"],
    [Op.SHL_REG_CONST, "shift", "shl", "const"],
    [Op.SHR_REG_REG, "shift", "shr", "gprReg"],
    [Op.SHR_REG_REGADDR, "shift", "shr", "regaddr"],
    [Op.SHR_REG_ADDR, "shift", "shr", "addr"],
    [Op.SHR_REG_CONST, "shift", "shr", "const"],
];
